const PROD_URL =
  "https://us-central1-build-smart-homes.cloudfunctions.net/api\n";

exports.BACKEND_URL = process.env.VUE_APP_BACKEND_URL
  ? process.env.VUE_APP_BACKEND_URL
  : PROD_URL;

// exports.BACKEND_URL = PROD_URL;
